<template>
  <b-card>
    <b-input-group size="sm" class="mb-2">
      <router-link to="/tuevs/import/wizard">
        <b-button class="mr-2">{{ $t('components.search_result.wizard_importacao') }}</b-button>
      </router-link>
      <b-form-input
          v-model="filter"
          type="search"
          id="filterInput"
          :placeholder="$t('components.search_result.pesquisar')"
      ></b-form-input>
      <b-input-group-append>
        <b-button :disabled="!filter" @click="filter = ''">
          {{ $t('components.search_result.limpar') }}
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-table primary-key="id" ref="result_table" :items="items" :filter="filter" :filter-included-fields="filterOn"
             :fields="main_table_labels" class="table-exams">

      <template v-slot:cell(status)="row">
        <strong>{{ row.value }}</strong>
      </template>

      <template v-slot:cell(acao)="row">
        <b-button size="sm" @click="row.toggleDetails">+</b-button>
      </template>

      <template v-slot:row-details="row">
        <b-card-group>
          <b-card :header="$t('components.search_result.informacoes_adicionais_cliente')">
            <b-table :items="getItem(row.index)" :fields="subfields"></b-table>
          </b-card>
          <b-card :header="$t('components.search_result.informacoes_adicionais_interacao')">
            <b-table :items="getItem(row.index)" :fields="integration_subfields"></b-table>
          </b-card>
          <b-card :header="$t('components.search_result.sinonimos')">
            <ul>
              <li v-for="synonym in getSynonyms(row.index)">{{ synonym }}</li>
            </ul>
          </b-card>
          <b-card header="TEUVS">
            <ul>
              <li v-for="tuevs in getTuevs(row.index)">{{ tuevs.code }}</li>
            </ul>
          </b-card>
        </b-card-group>
      </template>

    </b-table>
  </b-card>
</template>

<script>
import {mapGetters} from 'vuex'


export default {
  name: "SearchResult",
  methods: {
    filterTable(row, filter) {
      return row.nome_exame_cliente.includes(filter);
    },
    getItem(index) {
      return [this.items[index]]
    },
    getSynonyms(index) {
      return this.items[index]['sinonimia']
    },
    getTuevs(index) {
      return this.items[index]['tuevs_exam']
    },
  },
  computed: {
    ...mapGetters({
      items: 'tuevs/getExamsToSync',
      main_table_labels: 'tuevs/getMainTableFields',
      subfields: 'tuevs/getRowDetailsFields',
      integration_subfields: 'tuevs/getIntegrationRowDetails'
    }),
  },
  data() {
    return {
      filter: '',
      filterOn: ['status', 'mnemonico_exame', 'nome_exame', 'mnemonico_sub_exame']
    }
  }
}
</script>
<style></style>